export const useContactUsDetail = async () => {
  return useFetchSafely(() => `pages/contact-us`);
};
export const useGetStartedDetail = async () => {
  return useFetchSafelyCached("pages/get-started");
};
